import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

/**
 * Checks if the current time in Asia/Kolkata is within the specified window.
 * @param startHour 0-23
 * @param startMinute 0-59
 * @param endHour 0-23
 * @param endMinute 0-59
 */
export const isWithinTimeWindow = (
    startHour: number, 
    startMinute: number, 
    endHour: number, 
    endMinute: number
): boolean => {
    const tz = 'Asia/Kolkata';
    const now = toZonedTime(new Date(), tz);
    
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const startMinutes = startHour * 60 + startMinute;
    const endMinutes = endHour * 60 + endMinute;

    if (startMinutes <= endMinutes) {
        return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
    } else {
        // Overnight window
        return currentMinutes >= startMinutes || currentMinutes <= endMinutes;
    }
};

export const getISTTime = () => {
    return toZonedTime(new Date(), 'Asia/Kolkata');
};
